// src/pages/IndirectIncomeBalanceLedger/index.js
import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { PrinterOutlined } from "@ant-design/icons";
import { App, Button, Card, Grid, Typography } from "antd";
import IndirectIncomeBalanceLedgerFilters from "./components/IndirectIncomeBalanceLedgerFilters";
import IndirectIncomeBalanceLedgerTable from "./components/IndirectIncomeBalanceLedgerTable";
import ReportDom from "../../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";

const { Title } = Typography;

const IndirectIncomeBalanceLedger = () => {
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { filters } = useSelector((state) => state.indirectIncomeBalanceLedger);

  const reportRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Indirect Income Balance Ledger Report",
    removeAfterPrint: true,
  });

  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
            <Title level={4} style={{ margin: 0 }} className="reportBigTitle">
              Indirect Income Balance Ledger
            </Title>
          }
          extra={
            <Button
              type="primary"
              icon={<PrinterOutlined />}
              onClick={handlePrint}
            >
              { !screens.xs && "Print" }
            </Button>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <IndirectIncomeBalanceLedgerFilters messageApi={message} />

        <Card className="shadow-md rounded-xl">
          <IndirectIncomeBalanceLedgerTable />
        </Card>
      </App>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Indirect Income Balance Ledger Report"
          mode="report-page"
          filters={filters}
          renderTable={() => (
            <IndirectIncomeBalanceLedgerTable pagination={false} printMode={true} />
          )}
        />
      </div>
    </div>
  );
};

export default IndirectIncomeBalanceLedger;
